<template>
  <div style="width:100%">
    <v-simple-table :dense="false" :fixed-header="true">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              <div style="display:flex">
                <v-btn
                  v-on:click="toggleList"
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="green"
                  title="show expanded"
                >
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
                <v-btn
                  v-if="search"
                  v-on:click="clearSearch"
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="gray"
                  title="clear search"
                >
                  <v-icon>mdi-cancel</v-icon>
                </v-btn>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in _tasks" :key="item.id">
            <td>
              <Task
                :listMode="listMode"
                :item="item"
                :tasks="tasks"
                :currentBoardId="currentBoardId"
                :searcher="searcher"
                @focusOnTask="$emit('focusOnTask', $event)"
                @taskRenamed="taskRenamed"
                @taskChanged="taskChanged"
                @setForegroundTask="setForegroundTask"
                @helptask="$emit('helptask')"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import Task from "./Task";

export default {
  name: "TaskTable",
  components: {
    Task,
  },
  props: {
    currentBoardId: String,
    tasks: Array,
    loadingBoard: Boolean,
    searcher: Object,
  },
  data: () => ({
    listMode: true,
    search: "",
    taskTableHeader: [],
  }),
  computed: {
    _tasks: function () {
      // debugger; // eslint-disable-line
      if (this.search) {
        return this.searcher.search(this.search).map((i) => {
          return this.tasks.find((t) => t.id === i);
        });
      }
      return this.tasks;
      // return this.tasks.filter((t) =>
      //   t.title.toLowerCase().includes(this.search.toLowerCase())
      // );
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    toggleList() {
      this.listMode = !this.listMode;
    },
    taskRenamed() {
      this.$emit("taskRenamed");
    },
    taskChanged() {
      this.$emit("taskChanged");
    },
    setForegroundTask(item) {
      console.log(item);
      this.$emit("setForegroundTask", item);
    },
  },
};
</script>
